/**
 * @lastAudited 2025-01-19
 * @auditStatus PASS
 * @auditNotes Pre-publish checklist passed. No issues found.
 */
import { CityLandingPage } from '../city/CityLandingPage';
import { useSEOHead, SITE_URL } from '../../../hooks/useSEOHead';
import { PHONE_DISPLAY, BUSINESS_NAME } from '../../../lib/businessInfo';
import { useEffect } from 'react';
import { injectJsonLd, removeJsonLd } from '../../../lib/schemaBuilder';

export default function PortlandServiceAreaPage() {
  useEffect(() => {
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://rockhoundauto.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Service Areas',
          item: 'https://rockhoundauto.com/service-areas',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'Portland',
          item: 'https://rockhoundauto.com/service-areas/portland',
        },
      ],
    };

    injectJsonLd('schema-portland-service-breadcrumb', breadcrumbSchema);

    return () => {
      removeJsonLd('schema-portland-service-breadcrumb');
    };
  }, []);

  useSEOHead({
    title: 'Used Cars Portland OR — No Downtown Rent = Lower Prices | Rockhound Auto',
    description: 'Quality used cars serving Portland, OR. 90 minutes from downtown. No dealer markup. Honest pricing from a coastal dealer who doesn\'t pay downtown rent.',
    keywords: 'used cars Portland Oregon, Portland car dealer, cars near Portland OR',
    canonicalUrl: `${SITE_URL}/service-areas/portland`,
  });

  return (
    <>
      <CityLandingPage
        cityName="Portland"
        state="Oregon"
        distance="90 minutes"
        population="650,000+"
        heroImage="https://public.readdy.ai/ai/img_res/537a5dc5dd769f40f42ed5e62645d221.jpg"
        whyPeopleBuyHere="Portland buyers choose Rockhound Auto to escape metro dealer markups and high-pressure sales. The 90-minute drive saves thousands compared to Portland's inflated pricing. We offer transparent deals, no hidden fees, and a selection focused on practical vehicles—not just what manufacturers push. Worth the drive."
        whyTheyDrive="Portland buyers drive to Rockhound Auto for honest pricing and no-pressure sales. Metro dealers add $2,000-$4,000 in fees and markups. We publish all prices online, complete transactions in under an hour, and treat you like a person—not a commission check. The drive pays for itself."
        dealerInsight="Portland's competitive market means buyers are savvy and research-driven. They know metro dealer fees are inflated and they're willing to drive for better deals. We see Portland customers weekly who tell us the savings and stress-free experience made the trip worthwhile. Transparency wins."
        faqs={[
          // ... existing faqs ...
        ]}
      />
    </>
  );
}
